import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { SubscriberGroupSectionType } from '../metroline/types';
import { SubscriberGroupsSection } from '../types';
import { ExternalMembersTiles } from './external-members-tiles';

export const ExternalMembersContainer: React.FC<SubscriberGroupsSection> = ({
  subscriberGroupItem, translation, section, infoText, locale, validation,
  getRef, shouldRenderSection, updateExternalMemberItem, removeExternalMember,
  addExternalMember, removeAllExternalMembers, resetValidation
}) =>
  <MetroLineSection<SubscriberGroupSectionType>
    section={section}
    sectionType={SubscriberGroupSectionType.ExternalMembers}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(SubscriberGroupSectionType.ExternalMembers)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={SubscriberGroupSectionType.ExternalMembers}
        validation={undefined}
        info={{
          text: infoText,
          visible: true
        }}
        label={{ text: translation.external_members_title, visible: true }} />

      <MainGridContainer>
        <ExternalMembersTiles
          subscriberGroupItem={subscriberGroupItem}
          locale={locale}
          translation={translation}
          validation={validation}
          addExternalMember={addExternalMember}
          updateExternalMemberItem={updateExternalMemberItem}
          removeExternalMember={removeExternalMember}
          removeAllExternalMembers={removeAllExternalMembers}
          resetValidation={resetValidation} />
      </MainGridContainer>
    </div>
  </MetroLineSection>;
